import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { usePrevious } from 'hooks/use-previous';

export const useEffectOnUrlChange = (callback: () => void) => {
  const location = useLocation();
  const { pathname } = location;
  const previousPathname = usePrevious(pathname);

  useEffect(() => {
    if (previousPathname !== pathname) {
      callback();
    }
    // disabling the line to avoid unnecessary executions
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, previousPathname]);
};
